const STRAIGHT_QUOTE = '"';
const LEFT_DOUBLE_QUOTE = "\u201C";
const RIGHT_DOUBLE_QUOTE = "\u201D";

/** Wraps review copy in curly quotes unless the editor already included matching quotes. */
export function wrapReviewQuote(quote: string): string {
  const trimmed = quote.trim();
  if (!trimmed) return "";

  const isStraightQuoted =
    trimmed.startsWith(STRAIGHT_QUOTE) && trimmed.endsWith(STRAIGHT_QUOTE);
  const isCurlyQuoted =
    trimmed.startsWith(LEFT_DOUBLE_QUOTE) &&
    trimmed.endsWith(RIGHT_DOUBLE_QUOTE);

  if (isStraightQuoted || isCurlyQuoted) return trimmed;

  return `${LEFT_DOUBLE_QUOTE}${trimmed}${RIGHT_DOUBLE_QUOTE}`;
}
